import { Transaction } from './Transaction';

export class Activity {
    activity: string;
    brand: string;
    conceptName: string;
    expirationDate: string;
    formattedDate: string;
    location: string;
    locationCode: string;
    transactionDate: string;
    transactionMonth: string;
    transactions: Array<Transaction>;
}
